// Import Packages
import { useSetRecoilState, useRecoilValue, useRecoilState } from 'recoil';
import React, { useEffect, useState } from 'react';
import { useTranslation } from "react-i18next";

// Import Material UI
import { Button, Grid } from '@material-ui/core';
import { Edit } from "@material-ui/icons";

// Import Pages
import DataTable from "../../../../components/DataTable/DataTable";
import DataTableLoader from "../../../../components/ContentLoader/DataTableLoader";
import Search from "../../../../components/Search/Search";
import CustomizeView from "../../../../components/DataTable/CustomizeView/CustomizeView";
import Filters from "../../../../components/DataTable/Filters/Filters";
import DeleteConfirm from '../../../../components/DataTable/DeleteConfirm';
import { alertState, oauthState, rolePermission } from '../../../../recoil-store/recoil-state';
import ChooseApplication from '../chooseApplication/ChooseApplication';
import AppCredentialModal from "../appCredentialModal/AppCredentialModal";

// Import Services
import appService from "../../../../services/ApplicationService/ApplicationService";


let deletedAppCredentials = [];
let setSelectedAutomRow;
const ListAppCredentials = () => {
    const { t } = useTranslation();
    const [selectedApp, setSelectedApp] = useState({});
    const [openChooseApp, setOpenChooseApp] = useState(false);
    const [openAppCredential, setOpenAppCredential] = useState(false);
    const [appCredentialId, setAppCredentialId] = useState('');

    const [data, setData] = useState([]);
    const [refresh, setRefresh] = useState('');
    const [loading, setLoading] = useState(false); // default true
    const [searchData, setSearchData] = useState([])
    const [customColumn, setCustomColumn] = useState([])
    const [openCustomizeView, setOpenCustomizeView] = useState(false);
    const [openFilters, setOpenFilters] = useState(false);
    const [openDelete, setOpenDelete] = useState(false);
    const [loadingDelete, setLoadingDelete] = useState(false);
    const setAlert = useSetRecoilState(alertState);
    const permissions = useRecoilValue(rolePermission);
    const [oauthPopupState, setOauthPopupState] = useRecoilState(oauthState);
    const label = 'CONTENT.APP-CREDENTIAL.';

    useEffect(() => {
        fetchData().then(r => r);
    }, [refresh]);

    useEffect(() => {
        if (oauthPopupState) {
            setOpenAppCredential(false);
            fetchData().then(r => r);
        }
    }, [oauthPopupState]);

    async function fetchData() {
        setLoading(true);
        const response = await appService.getAppCredentialList();
        if (response?.status) {
            if (Array.isArray(response?.data)) {
                setData(response.data);
                setSearchData(response.data)

            } else {
                setData([]);
                setSearchData([])
            }
        }
        setLoading(false);
    }

    const handleRowsDelete = (rowsDeleted, dataArray, setSelectedRows) => {
        if (permissions?.data.includes('CUSTOMAUTOMS_DELETE')) {
            setOpenDelete(true);
            deletedAppCredentials = [];
            for (let i of rowsDeleted.data) {
                deletedAppCredentials.push(searchData[i.dataIndex].id);
            }
            setSelectedAutomRow = setSelectedRows;
        } else {
            setAlert(alert => ({
                ...alert,
                show: true,
                message: t("MESSAGES.AUTH-PAGES.RESET-PAGE.HASH-IS-NOT-PROVIDED"),
                severity: 'error'
            }))
        }
    };

    function handleOpen(open, setState) {
        setState(!open);
    }

    const deleteAppCredentials = async () => {
        let ids = deletedAppCredentials;
        setLoadingDelete(true);
        const response = await appService.deleteAppCredentials(ids);
        if (response) {
            setAlert(alert => ({
                ...alert,
                show: true,
                message: t(`MESSAGES.APP-CREDENTIAL.${response.message}`),
                severity: response.status ? 'success' : 'error'
            }))
            if (response.status) {
                setSelectedAutomRow([]);
                fetchData();
            }
        } else {
            setAlert(alert => ({ ...alert, show: true, message: t('GENERAL.NETWORK-ERROR'), severity: 'error' }))
        }
        setLoadingDelete(false);
    };

    const showUpdatePage = (appCredential) => {        
        setSelectedApp({
            id: appCredential.application_id,
            name: appCredential.application_name,
            image_path: appCredential.image_path,
            connector_fields: appCredential.connector_fields
        });
        setAppCredentialId(appCredential.id);
        setOpenAppCredential(true);
    }

    useEffect(() => {
        const column = [
            {
                id: 0,
                name: "id",
                label: " ",
                options: {
                    filter: false,
                    sort: false,
                    customBodyRenderLite: (dataIndex, rowIndex) => {
                        if (searchData && searchData[dataIndex]) {
                            return <span>{dataIndex + 1}.</span>;
                        }
                    },
                },
            },
            {
                id: 2,
                name: "name",
                label: t(label + "NAME"),
                options: { filter: true, sort: true },
            },
            {
                id: 3,
                name: "image_path",
                label: t(label + 'APPLICATION'),
                options: {
                    filter: true, sort: true,
                    customBodyRenderLite: (dataIndex) => {
                        if (searchData[dataIndex]) {
                            return <div><img title={searchData[dataIndex].application_name}
                                src={searchData[dataIndex].image_path} style={{ width: '10%' }} />
                            </div>
                        }
                    },
                }
            },
            {
                id: 4,
                name: "owner",
                label: t(label + 'OWNER'),
                options: {
                    filter: true, sort: true
                    // customBodyRenderLite: (dataIndex) => {
                    //     if (searchData[dataIndex]) {
                    //         return <span>{searchData[dataIndex].user.first_name + (searchData[dataIndex].user.second_name ? ' ' + searchData[dataIndex].user.second_name : '')}</span>;
                    //     }
                    // },
                },
            },
            {
                id: 11,
                name: "actions",
                label: " ",
                options: {
                    filter: false,
                    sort: false,
                    customBodyRenderLite: (dataIndex) => {
                        // Show edit icon if the status of the current autom is true and the user has less autom than specified in the license
                        return (
                            <Button onClick={() => showUpdatePage(searchData[dataIndex])}><Edit /></Button>
                            // <Link
                            //     data-test="autom-link"
                            //     to={`/automs/${searchData[dataIndex]?.id}/autom/edit`}
                            // >
                            //     <Edit />
                            // </Link>
                        );
                    },
                },
            },
        ]
        setCustomColumn(column)
    }, [searchData, t, setCustomColumn])

    const setApplication = (app) => {
        setSelectedApp(app);
        setOpenAppCredential(true);
    }

    const cancel = () => {
        setOpenAppCredential(false)
    }

    const changeApp = () => {
        setOpenAppCredential(false);
        setOpenChooseApp(true);
    }

    const afterSave = (t) => {
        setRefresh(t);
        setOpenAppCredential(false);
    }

    return (
        <div id="credential-container">
            <Search data={data} setSearchData={setSearchData} xs={11} sm={11} md={11} lg={4} xl={4} spacing={2}
                searchKey={['name', 'owner', 'application_name']}>
                <Grid item xs={12} sm={12} md={8} lg={8} xl={8}>
                    {/* <Link style={{ textDecoration: 'none' }} to="new">
                        <Button className="searchbar-button">{t('CONTENT.USER.CREATE-USER')}</Button>
                    </Link> */}
                    <Button onClick={() => {
                        setOpenChooseApp(true);
                        setAppCredentialId('')
                    }} className="searchbar-button">New Credential</Button>
                    <Button className="searchbar-button"
                        onClick={() => handleOpen(openCustomizeView, setOpenCustomizeView)}>{t('CONTENT.DATATABLE.TOOLBAR.CUSTOMIZE-VIEW')}</Button>
                    <Button className="searchbar-button"
                        onClick={() => handleOpen(openFilters, setOpenFilters)}>{t('CONTENT.DATATABLE.TOOLBAR.FILTERS')}</Button>
                </Grid>
            </Search>
            {
                loading ? <DataTableLoader /> :
                    <Grid
                        item
                        sm={12}
                        data-test="listautom-page"
                    >
                        <DataTable
                            data-test="automlist-datatable"
                            customColumns={customColumn}
                            onRowsDelete={handleRowsDelete}
                            selectableRows="multiple"
                            data={searchData ? searchData : []}
                            title={t("CONTENT.AUTOMS-LIST.AUTOM-LIST")}
                            loading={loading}
                            loadingDelete={loadingDelete}
                        />
                        {openChooseApp &&
                            <ChooseApplication setSelectedApp={setApplication} setOpen={setOpenChooseApp} />}

                        {openAppCredential &&
                            <AppCredentialModal selectedApp={selectedApp} setSelectedApp={setSelectedApp}
                                changeApp={changeApp}
                                setOpen={setOpenChooseApp} open={openChooseApp} afterSave={afterSave}
                                cancel={cancel} appCredentialId={appCredentialId} />}

                        {openDelete &&
                            <DeleteConfirm setOpenDelete={setOpenDelete} message={t("CONTENT.AUTOMS-LIST.DELETE-WARNING")}
                                deleteFunc={deleteAppCredentials} />}
                        {openCustomizeView && <CustomizeView setOpen={setOpenCustomizeView} customColumn={customColumn}
                            setCustomColumn={setCustomColumn} />}
                        {openFilters &&
                            <Filters setOpen={setOpenFilters} customColumn={customColumn}
                                setCustomColumn={setCustomColumn} />}
                    </Grid>
            }
        </div>
    );
};

export default ListAppCredentials;
